var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3797 11.8344H13.5391C13.4734 11.8344 13.4187 11.8891 13.4187 11.9547V12.9203H3.57969V3.07969H13.4203V4.04531C13.4203 4.11094 13.475 4.16563 13.5406 4.16563H14.3813C14.4469 4.16563 14.5016 4.1125 14.5016 4.04531V2.47969C14.5016 2.21406 14.2875 2 14.0219 2H2.97969C2.71406 2 2.5 2.21406 2.5 2.47969V13.5203C2.5 13.7859 2.71406 14 2.97969 14H14.0203C14.2859 14 14.5 13.7859 14.5 13.5203V11.9547C14.5 11.8875 14.4453 11.8344 14.3797 11.8344ZM14.6703 7.90156L12.4531 6.15156C12.3703 6.08594 12.25 6.14531 12.25 6.25V7.4375H7.34375C7.275 7.4375 7.21875 7.49375 7.21875 7.5625V8.4375C7.21875 8.50625 7.275 8.5625 7.34375 8.5625H12.25V9.75C12.25 9.85469 12.3719 9.91406 12.4531 9.84844L14.6703 8.09844C14.6853 8.08674 14.6973 8.0718 14.7056 8.05475C14.714 8.03769 14.7183 8.01897 14.7183 8C14.7183 7.98103 14.714 7.96231 14.7056 7.94525C14.6973 7.92819 14.6853 7.91326 14.6703 7.90156Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportOutlined);
export default __webpack_public_path__ + "static/media/ExportOutlined.d685efc3bd4898baecfb810aa8f4f618.svg";
export { ForwardRef as ReactComponent };